export default __webpack_public_path__ + "static/playground-thumb-e870964790122d70da2952b8d6cdc413.jpg";